<template>
  <div class="flex">
    <el-popover
        placement="right"
        v-model="sortby_visible"
        width="200"
        >
        <div>
            <h2>Sort By</h2>
            <el-form class="sortby-form" :model="form" ref="form" >
                <elsa-select
                    class="select-sortby"
                    name="selectedSortby"
                    placeholder="select sortby"
                    :options="sortby"
                    v-model.lazy="form.sortby"
                    @change="onChange"
                />
                <elsa-select
                    class="select-sortorder"
                    name="selectedSortOrder"
                    placeholder="select sort order"
                    :options="sortorder"
                    v-model.lazy="form.sortorder"
                    @change="onChange"
                />
                <!-- <div style="text-align: right; margin: 0">
                    <el-button type="primary" size="mini" @click="applySorting">Apply</el-button>
                </div> -->
            </el-form>
        </div>
        <span class="el-table__column-filter-trigger sort-by-option" slot="reference">
            <i class="el-icon-sort"></i>
            <label>Sort By</label>
            <label>{{currentSortby}}</label>
            <i v-if="form.sortorder == 'asc'" class="el-icon-top"></i>
            <i v-else class="el-icon-bottom"></i>
            <i class="el-icon-caret-bottom"></i>
        </span>
    </el-popover>
  </div>
</template>

<script>
import ElsaSelect from '@/components/common/Select'
import { propOr, propEq, find, compose } from 'ramda'
  export default {
    components: {
        ElsaSelect
    },
    data() {
      return {
        sortby_visible: false,
        form: {sortby: 'start_date', sortorder: 'desc'},
        sortby: [
            {label: 'Name', value: 'name'},
            {label: 'Timeline', value: 'start_date'},
        ],
        sortorder: [
            {label: 'Ascending', value: 'asc'},
            {label: 'Descending', value: 'desc'},
        ],
      }
    },
    props: {
        ordering: {
            type: String,
            default: '-start_date'
        },
    },
    methods: {
      onChange() {
          this.sortby_visible = false;
          if(this.form.sortorder == "asc") {
              this._ordering = `${this.form.sortby}`;
          } else {
              this._ordering = `-${this.form.sortby}`;
          }
          this.$emit("sort-func");
      }
    },
    computed: {
      currentSortby() {
          let sortby = compose(propOr('Name', 'label'), find(propEq('value', this.form.sortby)))(this.sortby);
          return sortby;
      },
      _ordering: {
        get() {
            return this.ordering
        },
        set(ordering) {
            this.$emit('update:ordering', ordering)
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
@import "../../scss/_colors.scss";
.sortby-form {
    padding-top: 20px; 
}
.sort-by-option {
    display: flex;
    align-items: center;
    border: 1px solid #e6e6e6;
    padding: 6px;
    border-radius: 8px;
    label:first-of-type {
        padding-right: 20px; 
    }
}
::v-deep .el-input .el-input__inner {
    height: 40px !important;
}
::v-deep .el-table__column-filter-trigger i {
    font-size: 23px !important;
}
.el-icon-caret-bottom {
    padding-left: 10px;
}
</style>
